import React from "react";
import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { PMG_CONSTANTS } from "../constant";
import { get } from "lodash";
import htmlToFormattedText from "html-to-formatted-text";
import { toast } from "react-toastify";
import { successToastStyle } from "../customToast";

// PMG Invest (POST)

export const pmgAddMemberFormAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.pmgAddMemberForm(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;

      // dispatch({
      //   type: PMG_CONSTANTS.PMG_FORM_SUCCESS,
      //   payload,
      // });
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_FORM_FAILURE);
    });
};

// PMG Invest (GET)

export const getPmgInvestAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getPmgInvestApi(params))
    .then(response => {
      console.log("from invest action", response.data);
      const payload = response.data.data;
      localStorage.setItem("pmgList", JSON.stringify(payload));

      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.PMG_FORM_GET_FAILURE);
    });
};

// PMG Invest (EDIT)

export const pmgEditMemberFormAction = (
  params,
  id,
  requestMethod = request
) => {
  return requestMethod(apiServices.pmgEditMemberFormApi(params, id))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_FORM_UPDATE_FAILURE);
    });
};

// DPIIT ADD

export const dpiitAddMemberFormAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.dpiitAddMemberForm(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.DPIIT_FAILURE);
    });
};

// DPIIT GET
export const getDpiitInvestAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getDpiitInvestApi(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.DPIIT_GET_FAILURE);
    });
};

// DPIIT UPDATE
export const dpiitEditMemberFormAction = (
  params,
  id,
  requestMethod = request
) => {
  return requestMethod(apiServices.dpiitEditMemberFormApi(params, id))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.DPIIT_UPDATE_FAILURE);
    });
};

//SECTION ADD
export const sectionAddMemberFormAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.sectionAddMemberForm(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.SECTION_FAILURE);
    });
};

//SECTION GET
export const getSectionInvestAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.sectionPmgInvestApi(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.SECTION_GET_FAILURE);
    });
};

//SECTION EDIT
export const sectionEditMemberFormAction = (
  params,
  id,
  requestMethod = request
) => {
  return requestMethod(apiServices.sectionEditMemberFormApi(params, id))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.SECTION_UPDATE_FAILURE);
    });
};

//HEADING ADD
export const headingAddAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.headingAdd(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_HEADING_FAILURE);
    });
};

export const getHeadingAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getHeadingg(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.PMG_HEADING_GET_FAILURE);
    });
};

//HEADING GET
export const getHeadingAction1 = (
  params,
  requestMethod = request
) => async dispatch => {
  return requestMethod(apiServices.getHeadingg(params))
    .then(response => {
      console.log("from invest action", response.data);
      dispatch({
        type: PMG_CONSTANTS.HEADING_DETAILS_SUCCESS,
        payload: response.data.data
      });
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.PMG_HEADING_GET_FAILURE);
    });
};

//HEADING EDIT
export const editHeadingAction = (
  params,
  id,
  requestMethod = request
) => async dispatch => {
  return requestMethod(apiServices.headingUpdate(params, id))
    .then(pmgResponse => {
      requestMethod(apiServices.getHeadingg(params))
        .then(response => {
          dispatch({
            type: PMG_CONSTANTS.HEADING_DETAILS_SUCCESS,
            payload: response.data.data
          });
        })
        .catch(err => {
          console.log(PMG_CONSTANTS.PMG_HEADING_GET_FAILURE);
        });
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_HEADING_UPDATE_FAILURE);
    });
};

// PMG UPDATE (POST)

export const pmgUpdateAddMemberFormAction = (
  params,
  requestMethod = request
) => {
  return requestMethod(apiServices.pmgUpdateAddMemberForm(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_UPDATE_ADD_FAILURE);
    });
};

// PMG UPDATE (GET)

export const getPmgUpdateAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getPmgUpdateApi(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.PMG_UPDATE_GET_FAILURE);
    });
};

// PMG UPDATE (EDIT/UPDATE)

export const pmgMemberUpdateFormAction = (
  params,
  id,
  requestMethod = request
) => {
  return requestMethod(apiServices.pmgMemberUpdateApi(params, id))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_UPDATE_EDIT_FAILURE);
    });
};

////// Landing Page

export const getDpiit = (params, requestMethod = request) => {
  return requestMethod(apiServices.getDpiitLandingCms(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.DPIIT_GET_FAILURE_LANDINGPAGE);
    });
};

export const getPmg = (params, requestMethod = request) => {
  return requestMethod(apiServices.getPmgLandingCms(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.PMG_GET_FAILURE_LANDINGPAGE);
    });
};

export const getSection = (params, requestMethod = request) => {
  return requestMethod(apiServices.getSectionLandingCms(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.SECTION_GET_FAILURE_LANDINGPAGE);
    });
};

export const getUpdate = (params, requestMethod = request) => {
  return requestMethod(apiServices.getPmgUpdateLandingCms(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.UPDATE_GET_FAILURE_LANDINGPAGE);
    });
};

export const getHeading = (params, requestMethod = request) => {
  return requestMethod(apiServices.getHeadingLandingCms(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.HEADING_GET_FAILURE_LANDINGPAGE);
    });
};

/////////////// Drag & Drop Order

export const dpiitSortOrderAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.dpiitOrder(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.DPIIT_SORT_FAILURE);
    });
};

export const investIndiaSortOrderAction = (
  params,
  id,
  requestMethod = request
) => {
  return requestMethod(apiServices.investIndiaOrder(params, id))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.INVEST_SORT_FAILURE);
    });
};

export const sectionSortOrderAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.sectionOrder(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.SECTION_SORT_FAILURE);
    });
};

export const pmgInvestSortOrderAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getInvestIndiaSortedOrder(params))
    .then(pmgResponse => {
      const payload = pmgResponse.data;
      return payload;
    })
    .catch(() => {
      //console.log(PMG_CONSTANTS.INVEST_SORT_GET_FAILURE);
    });
};

// export const pmgInvestSortOrderAction1 = (params, requestMethod = request) => {
//   return requestMethod(apiServices.getInvestIndiaSortedOrder(params))
//     .then(pmgResponse => {
//       const payload = pmgResponse.data;
//       return payload;
//     })
//     .catch(() => {
//       //console.log(PMG_CONSTANTS.INVEST_SORT_GET_FAILURE);
//     });
// };

export const pmgInvestSortOrderAction1 = (params, requestMethod = request) => {
  return function(dispatch) {
    console.log("params----------------", params);
    dispatch({
      type: PMG_CONSTANTS.INVEST_SORT_START
    });
    return requestMethod(apiServices.getInvestIndiaSortedOrder(params))
      .then(Response => {
        console.log("misResponse", Response);
        const payload = Response.data;
        dispatch({
          type: PMG_CONSTANTS.INVEST_SORT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: PMG_CONSTANTS.INVEST_SORT_GET_FAILURE
        });
      });
  };
};

export const getDpiitSortAction = (params, requestMethod = request) => {
  console.log("from Dpiit", params);
  return requestMethod(apiServices.getDpiitSortOrder(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.DPIIT_SORT_GET_SUCCESS);
    });
};

export const getPmgSortAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getInvestIndiaSortOrder(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.INVEST_SORT_GET_FAILURE);
    });
};

export const getSectionSortAction = (params, requestMethod = request) => {
  return requestMethod(apiServices.getSectionSortOrder(params))
    .then(response => {
      console.log("from invest action", response.data);
      return response.data;
    })
    .catch(err => {
      console.log(PMG_CONSTANTS.SECTION_SORT_GET_FAILURE);
    });
};

//Ashish sir
export const validatePMGTeamFlds = (
  data,
  sectionName,
  requestMethod = request
) => {
  let requiredURL = "";
  if (sectionName === "dpiit") {
    requiredURL = "/project/cms/fields-validations/dpiit";
  } else if (sectionName === "pmg") {
    requiredURL = "/project/cms/fields-validations/invest-india";
  } else {
    requiredURL = "/project/cms/fields-validations/section";
  }
  return requestMethod(apiServices.validatePMGTeamFlds(data, requiredURL))
    .then(pmgResponse => {
      console.log("AshishAPI", pmgResponse);
      return pmgResponse.data;
    })
    .catch(() => {
      console.log(PMG_CONSTANTS.PMG_FORM_FAILURE);
    });
};
